import { Link } from "theme-ui";
import * as React from 'react';
export default {
  Link,
  React
};